/** URL slug from a title: lowercase a-z, 0-9 and single hyphens, at most 80 characters. */
export function slugifyTitle(title: string): string {
  return title
    .trim()
    .toLowerCase()
    // "Ünïcode" -> "Unicode": split accents off their letters, then drop them.
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

/**
 * Keeps a slug in step with its title until someone edits the slug by hand: returns the slug to
 * use after the title changed, given the slug this helper produced last time.
 */
export function followTitleSlug(title: string, currentSlug: string, lastAutoSlug: string): string {
  if (currentSlug && currentSlug !== lastAutoSlug) return currentSlug;
  return slugifyTitle(title || '');
}
